<p>search-multiple-user works!</p>
